import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import NavBar from "../Components/NavBar/NavBar";
import Footer from "../Components/Footer/Footer";
import { Helmet } from "react-helmet";

const CloudMigration = () => {
  return (
    <div>
      <Helmet>
        <title>Cloud Migration| Dhanam Infosys</title>
      </Helmet>

      <NavBar />
{/* Hero Section */}
<section className="about-hero text-white text-center py-5">
        <Container>
          <h1 className="fw-bold mb-3">Accelerate Your Cloud Journey with Confidence and Expertise
</h1>
          <p className="lead">
          At Dhanam Information Systems, we help enterprises seamlessly migrate applications, databases,
          and infrastructure to the cloud, ensuring business continuity, reduced risk, and maximized ROI.
          </p>
        </Container>
      </section>
      <Container className="py-5 bg-light">      

        <Card className="mb-5 shadow">
          <Card.Body>
            <Card.Title className="text-primary">🔹 Our Cloud Migration Offerings:</Card.Title>
            <ul className="mt-3">
              <li><strong>Cloud Readiness Assessment:</strong> Evaluate your existing IT landscape to identify cloud-compatible workloads, cost optimization opportunities, and migration feasibility.</li>
              <li><strong>Migration Planning & Strategy:</strong> Define a structured cloud roadmap, choose the right deployment model (public, private, hybrid), and select the ideal cloud platform (AWS, Azure, GCP).</li>
              <li><strong>Application & Database Migration:</strong> Migrate legacy applications, web platforms, and databases to the cloud with minimal downtime and zero data loss.</li>
              <li><strong>Infrastructure Migration:</strong> Rehost (lift-and-shift), replatform, or refactor on-premise infrastructure to cloud-native environments for scalability and cost efficiency.</li>
              <li><strong>DevOps & Automation Integration:</strong> Streamline deployment pipelines using CI/CD tools, infrastructure as code (IaC), and automated monitoring.</li>
              <li><strong>Post-Migration Support & Optimization:</strong> Continuous performance tuning, security checks, cost monitoring, and support to ensure optimal cloud operations.</li>
            </ul>
          </Card.Body>
        </Card>

        <Row className="mb-5">
          <Col md={6}>
            <Card className="shadow-sm">
              <Card.Body>
                <Card.Title className="text-success">🔹 Why Dhanam Information Systems?</Card.Title>
                <ul>
                  <li>Certified AWS, GCP, Azure Experts</li>
                  <li>Proven frameworks for risk-free migration</li>
                  <li>Deep experience in regulated industries</li>
                  <li>24/7 post-migration monitoring & support</li>
                  <li>Security-first approach with compliance alignment (ISO, GDPR, HIPAA)</li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} className="d-flex align-items-center">
            <div>
              <h4 className="text-dark">
                Modernize your enterprise IT and unlock the power of the cloud.
              </h4>
              <p>
                Choose Dhanam Information Systems to lead your cloud migration — with strategic planning,
                expert execution, and enterprise-grade support.
              </p>
              <Button variant="primary" href="https://dhanaminfosys.com/" target="_blank">
                Visit Website
              </Button>
            </div>
          </Col>
        </Row>
      </Container>

      <Footer />

      {/* Scoped Styles */}
      <style jsx>{`
        .about-hero {
          background-color: rgb(11, 22, 63);
        }

        ul {
          list-style: none;
          padding-left: 0;
        }
        ul li::before {
          margin-right: 10px;
          color: green;
        }
      `}</style>
    </div>
  );
};

export default CloudMigration;
